import { RadioGroupField } from 'lib/iterable-hook-form';
import { getIsNodeEditorReadOnly, getStartNodeTriggerNodeClass } from 'modules/workflows/ducks';
import { useSelector } from 'react-redux';
import { useIsMatchTriggeringEventSelected } from '../YesNoSplitEditor.hooks';
import { getRadioOptions } from './YesNoSplitToggle.utils';
import { RadioListWrapper } from './styles';

export const YesNoSplitToggle = () => {
  const startNodeClass = useSelector(getStartNodeTriggerNodeClass);
  const isTileEditorReadOnly = useSelector(getIsNodeEditorReadOnly);

  const isMatchTriggeringEventSelected = useIsMatchTriggeringEventSelected();

  return (
    <RadioListWrapper>
      <RadioGroupField
        name="matchTriggeringEventFields"
        radioAlignment="flex-start"
        options={getRadioOptions({
          startNodeClass,
          isReadOnly: isTileEditorReadOnly,
          isMatchTriggeringEventSelected,
        })}
      />
    </RadioListWrapper>
  );
};
